import { z } from 'zod';
// Flagging an item as important for a colleague (t1377). The type strings are
// stored in the database, so they are never renamed.
export const IMPORTANT_ITEM_TYPES = [
    'support_ticket',
    'task',
    'order',
    'customer',
    'repair',
    'rental',
    'purchase_order',
    'vendor',
];
/** Where each item type's page lives in the admin portal. */
export const IMPORTANT_ITEM_PATHS = {
    support_ticket: '/support-tickets/',
    task: '/tasks/',
    order: '/orders/',
    customer: '/customers/',
    repair: '/repairs/',
    rental: '/rentals/',
    purchase_order: '/purchase-orders/',
    vendor: '/vendors/',
};
export const importantItemTypeSchema = z.enum(IMPORTANT_ITEM_TYPES);
export const createImportantFlagSchema = z.object({
    itemType: importantItemTypeSchema,
    itemId: z.string().uuid(),
    recipientIds: z.array(z.string().uuid()).min(1).max(20),
    note: z.string().trim().max(500).optional(),
});
export const importantFlagSchema = z.object({
    id: z.string().uuid(),
    itemType: z.string(),
    itemId: z.string().uuid(),
    label: z.string(),
    url: z.string(),
    note: z.string().nullable(),
    createdAt: z.string(),
    createdByName: z.string().nullable(),
    createdById: z.string().uuid().nullable(),
    recipientId: z.string().uuid(),
    recipientName: z.string(),
});
export const importantFlagQuerySchema = z.object({
    itemType: importantItemTypeSchema,
    itemId: z.string().uuid(),
});
export const importantRecipientSchema = z.object({ id: z.string().uuid(), name: z.string() });
//# sourceMappingURL=important.js.map